<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      ВСН 012-88 (Часть 2)
    </div>
    <div class="chapter-title">Журнал <br> сварки труб <n-input title="(на трассе, трубосварочной базе, площадке)" v-bind="$form.input('p1.1')" :text="!editable" /></div>
    <div>на участке от км/ПК <n-input title="Пункт" v-bind="$form.input('p1.2')" :text="!editable" />  до км/ПК  <n-input title="Объект " v-bind="$form.input('p1.3')" :text="!editable" /></div>
    <div>Производитель работ <n-input title="(должность, организация, фамилия, инициалы)" v-bind="$form.input('p1.4')" :text="!editable" /></div>
    <n-items v-if="project">
      <n-input title="Начало работ" v-bind="$form.input('p1.5')" :text="!editable" />
      <n-input title="Окончание работ" v-bind="$form.input('p1.6')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
